import { useNavigate } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

interface BreadcrumbItem {
  label: string;
  onClick?: () => void;
}

interface DashboardBreadcrumbProps {
  role: string;
  activeTab: string;
  onTabClick?: () => void;
}

const DashboardBreadcrumb = ({ role, activeTab, onTabClick }: DashboardBreadcrumbProps) => {
  const navigate = useNavigate();

  const items: BreadcrumbItem[] = [
    { label: "Home", onClick: () => navigate("/") },
    { label: "App", onClick: () => navigate("/app") },
    { label: role },
  ];

  if (activeTab) {
    items.push({ label: activeTab, onClick: onTabClick });
  }

  return (
    <nav className="px-4 py-2 border-b border-[hsl(var(--app-border-subtle))] app-surface-1">
      <ol className="flex items-center gap-1 text-[11px] font-medium max-w-5xl mx-auto">
        {items.map((item, i) => {
          const isLast = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-1">
              {i === 0 && <Home className="w-3 h-3 text-[hsl(var(--app-text-muted))] mr-0.5" />}
              {i > 0 && <ChevronRight className="w-3 h-3 text-[hsl(var(--app-text-muted)/0.4)]" />}
              {isLast ? (
                <span className="text-[hsl(var(--app-gold))]">{item.label}</span>
              ) : (
                <button
                  onClick={item.onClick}
                  className="text-[hsl(var(--app-text-muted))] hover:text-[hsl(var(--app-text-secondary))] transition-colors"
                >
                  {item.label}
                </button>
              )}
            </li>
          );
        })}
      </ol>
    </nav>
  );
};

export default DashboardBreadcrumb;
